import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { FormattedMessage } from 'react-intl';
import { Typography } from 'views/components/atoms/Typography';
import { Button } from 'views/components/atoms/Button';
import { Color, FontSize, MAX_WIDTH } from 'views/constants';
import styled from '@emotion/styled';
import { Spacer } from 'views/components/atoms/Spacer';
import { Image } from 'views/components/atoms/Image';
import { InputText } from 'views/components/atoms/InputText';
import { LinkButton } from 'views/components/molecules/LinkButton';
import safariInactiveImage from 'views/layouts/RequiredIphonePageLayout/images/safari_icon_inactive.png';
import safariActiveImage from 'views/layouts/RequiredIphonePageLayout/images/safari_icon_active.png';
import { localeIds } from 'locals';

const URL = styled.div`
  margin: 0 auto;
  max-width: 80%;
  padding: 12px 8px;
  border: 1px solid ${Color.C4};
`;

const ImageWrapper = styled.div`
  max-width: 100px;
  margin: 0 auto;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  max-width: ${MAX_WIDTH};
`;

function doNothing(): void {
  // do nothing
}

function copyUrl(): void {
  const copyText = document.getElementById(
    'login-user-page'
  ) as HTMLInputElement;

  if (copyText) {
    copy(copyText.value);
  }
}

export const RequiredIosSafariPageLayout: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const handleCopy = React.useCallback(() => {
    copyUrl();
    setCopied(true);
  }, [setCopied, copyUrl]);

  return (
    <>
      <Spacer size="large" />
      <Typography el="p" color={Color.C2} bold>
        <FormattedMessage id={localeIds.error.notSafari.requiredSafari} />
      </Typography>
      <Spacer size="large" />
      <ImageWrapper>
        <Image src={copied ? safariActiveImage : safariInactiveImage} />
      </ImageWrapper>
      <Spacer />
      <Typography el="p" color={Color.C3} size={FontSize.S} block>
        <FormattedMessage
          id={localeIds.error.notSafari.copyHtml}
          values={{ br: <br /> }}
        />
      </Typography>
      <Spacer />
      <URL>
        <InputText
          id="login-user-page"
          defaultValue={window.location.href}
          disabled
          onChange={doNothing}
        />
      </URL>
      <Spacer />
      <ButtonWrapper>
        {copied ? (
          <LinkButton
            label={
              <FormattedMessage id={localeIds.error.notSafari.openSafari} />
            }
            to="x-web-search://"
            anotherTab
          />
        ) : (
          <Button type="button" onClick={(): void => handleCopy()}>
            <FormattedMessage id={localeIds.error.notSafari.copyUrl} />
          </Button>
        )}
      </ButtonWrapper>
    </>
  );
};
